import { gql, useMutation } from '@apollo/client';
import { PROJECT_PAGE_FRAGMENT } from '../gql/projectPageFragment';
import { get } from 'lodash';
import { useCallback } from 'react';
import toast from 'helpers/toast';
import { translate } from 'javascripts/translations/i18n';

const SET_PROJECT_PAGE_TITLE = gql`
  mutation SetProjectPage($input: SetProjectPageTitleInput!) {
    setProjectPageTitle(input: $input) {
      errors {
        error
        message
      }
      page {
        __typename
        ...ProjectPageFragment
      }
    }
  }
  ${PROJECT_PAGE_FRAGMENT}
`;

const useUpdatePageTitle = () => {
  const [updatePageTitleMutation, { loading }] = useMutation(
    SET_PROJECT_PAGE_TITLE,
    {
      onCompleted: (res) => {
        const errors = get(res, 'setProjectPageTitle.errors', null);
        if (errors.length) {
          toast.error(translate('projectPage.hooks.updateTitleError'));
        }
      },
      onError: () => {
        toast.error(translate('projectPage.hooks.updateTitleError'));
      },
    },
  );

  const updatePageTitle = useCallback(
    ({ pageId, title }) =>
      updatePageTitleMutation({
        variables: {
          input: {
            pageId,
            title,
          },
        },
      }),
    [updatePageTitleMutation],
  );

  return {
    updatePageTitle,
    loading,
  };
};

export default useUpdatePageTitle;
